import React, {Component, PropTypes} from 'react';
import {Tag, Icon} from 'antd';
import {style} from '../style';
import {Map} from 'immutable';
import {parseUsername} from '../../util';
import moment from 'moment';
import 'moment/locale/vi';

moment.locale('vi-VN');

export default class TrackerTag extends Component {
    static propTypes = {
        overviewByTrackers: PropTypes.array,
        issuesMap: PropTypes.object,
        usersMap: PropTypes.object,
        pushIssues: PropTypes.string,
    };

    static defaultProps = {
        overviewByTrackers: [],
        issuesMap: Map,
        usersMap: Map,
        pushIssues: '',
    };

    getIssuesTime() {
        let eventStartTime = '';
        let eventEndTime = '';

        if (this.props.event.startTime) {
            const arrStartTime = this.props.event.startTime.split(':');

            if (arrStartTime.length > 1) {
                eventStartTime = `${arrStartTime[0]}:${arrStartTime[1]}`;
            } else {
                eventStartTime = moment(this.props.event.startTime).format('HH:mm');
            }
        } else {
            eventStartTime = moment(this.props.event.startDate).format('HH:mm');
        }

        if (this.props.event.dueTime) {
            const arrEndTime = this.props.event.dueTime.split(':');
            if (arrEndTime.length > 1) {
                eventEndTime = `${arrEndTime[0]}:${arrEndTime[1]}`;
            } else {
                eventEndTime = moment(this.props.event.dueTime).format('HH:mm');
            }
        } else {
            eventEndTime = moment(this.props.event.dueDate).format('HH:mm');
        }

        return `${eventStartTime} - ${eventEndTime}`;
    }

    getCreateTime() {
        let createTime = '';

        if (this.props.event.createdOn) {
            createTime = moment(this.props.event.createdOn).utcOffset('+0000').format('DD-MM-YYYY HH:mm:ss');
        }

        return createTime;
    }

    getIssuesTracker() {
        let trackerName = this.props.event.trackerName;
        if (this.props.event.trackerMore) {
            this.props.event.trackerMore.split(',').map((trackerID) => {
                return this.props.overviewByTrackers.map((tracker) => {
                    if (tracker.trackerID === parseInt(trackerID)) {
                        trackerName += ` - ${tracker.name}`;
                    }
                });
            });
        }

        if (trackerName === undefined) {
            return '...';
        }
        return trackerName;
    }

    getUserName(userID) {
        if (userID && userID > 0) {
            let user = this.props.usersMap.get(userID.toString());
            if (user) {
                return parseUsername(user.get('firstname'), user.get('lastname'));
            }
        }

        return '';
    }

    render() {
        return (
            <span>
                <Tag
                    style={style.tagCustom}
                >
                    <Icon style={style.issueIcon} type="solution"/>
                    {`${this.getUserName(this.props.event.saleID)} - ${this.props.event.username}`}
                </Tag>
                <Tag
                    style={style.tagCustom}
                >
                    <Icon style={style.issueIcon} type={this.props.event.trackerMore ? "tags-o" : "tag-o"}/>
                    {this.getIssuesTracker()}
                </Tag>
                <Tag
                    style={style.tagCustom}
                >
                    <Icon style={style.issueIcon} type="clock-circle-o"/>
                    {this.getIssuesTime()}
                </Tag>
                <Tag
                    style={style.tagCustom}
                >
                    <Icon style={style.issueIcon} type="environment-o"/>
                    <p style={{
                        lineHeight: '18px',
                        display: '-webkit-box',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        maxHeight: '35px',
                        marginBottom: '3px'
                    }}>
                        {this.props.event.clientAddress ? this.props.event.clientAddress : '...'}
                    </p>
                </Tag>
                <Tag
                    style={style.tagCustom}
                >
                    <Icon style={style.issueIcon} type="layout"/>
                    <p style={{
                        lineHeight: '18px',
                        display: '-webkit-box',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxHeight: '75px',
                    }}>
                        {this.props.event.description ? this.props.event.description : '...'}
                    </p>
                </Tag>
                <div style={{height: '25px', width: '100%', position: 'relative', float: 'left'}}></div>
            </span>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/schedule/issues/tracker/tracker.js